import React, { Component } from 'react';
import { arrayOf, bool, func, number, oneOfType, shape, string } from 'prop-types';
import classnames from 'classnames';
import Job from './Job';
import Pagination from 'ps-components/Pagination/Pagination';
import Search from 'ps-components/Search/Search';
import Placeholder from 'ps-components/Placeholder/Placeholder';
import './SearchResults.scss';

const ENTER_KEY = 13;
const STEP = 50;
class SearchResults extends Component {
  static propTypes = {
    className: string,
    clearSelectedJobs: func,
    hasResults: bool,
    isSelected: bool,
    offset: number,
    orgJobs: arrayOf(
      shape({
        id: string,
        orgJobId: string,
        org_job_code: string,
        org_job_code_key: string,
        org_job_title: string
      })
    ),
    pageOrgJobs: func,
    replacementTokens: arrayOf(
      shape({
        key: string
      })
    ),
    search: func,
    searchId: string,
    searchText: string,
    selectedJob: shape({
      code: string,
      codeKey: string,
      currency: string,
      description: string,
      descriptionDocument: shape({
        fileLocation: string,
        title: string
      }),
      employeeCount: oneOfType([string, number]),
      id: oneOfType([string, number]),
      jobMatches: arrayOf(
        shape({
          id: string,
          orgJob: shape({
            id: string
          }),
          surveyJob: shape({
            code: string,
            description: string,
            id: string,
            survey: shape({
              code: string,
              id: string,
              name: string
            }),
            title: string
          })
        })
      ),
      name: string
    }),
    setSeachText: func,
    setSelectedJob: func,
    showSearch: bool,
    toggleDetail: func,
    toggleShowSelectedSurveyJobs: func,
    totalCount: number,
    useJobCodeKey: bool
  };

  componentDidMount() {
    const { searchId } = this.props;
    const searchBox = document.getElementById(searchId);
    if (searchBox) searchBox.addEventListener('keydown', e => this.searchByText(e));
  }

  componentDidUpdate(prevProps, prevState) {
    const { showSearch, searchId } = this.props;

    if (showSearch && showSearch !== prevProps.showSearch) {
      const searchBox = document.getElementById(searchId);
      if (searchBox) searchBox.addEventListener('keydown', e => this.searchByText(e));
    }
  }

  componentWillUnmount() {
    const { searchId } = this.props;
    const searchBox = document.getElementById(searchId);
    if (searchBox) searchBox.removeEventListener('keydown', e => this.searchByText(e));
  }

  clearSearch = () => {
    const { search, setSearchText } = this.props;

    search('');
    setSearchText('');
  };

  getText = event => {
    const { setSearchText } = this.props;

    event.persist();
    const value = event.target.value;
    setSearchText(value);
  };

  renderJobs = () => {
    const { orgJobs, replacementTokens, selectedJob, useJobCodeKey } = this.props;

    return orgJobs.map(job => {
      const jobClass = classnames({
        job: true,
        job__selected: selectedJob && parseInt(selectedJob.id) === parseInt(job.orgJobId)
      });

      return (
        <Job
          className={jobClass}
          job={job}
          key={job.id}
          replacementTokens={replacementTokens}
          setSelectedJob={this.setSelectedJob}
          useJobCodeKey={useJobCodeKey}
        />
      );
    });
  };

  searchByText(e) {
    const { isSelected, search, searchText } = this.props;

    if (e.keyCode == ENTER_KEY && isSelected) {
      search(searchText);
    }
  }

  setSelectedJob = job => {
    const { isSelected, setSelectedJob, showSearch, toggleDetail, toggleShowSelectedSurveyJobs } = this.props;

    setSelectedJob(job);

    if (!isSelected) toggleShowSelectedSurveyJobs();
    if (showSearch) toggleDetail();
  };

  toggleDetail = () => {
    const { clearSelectedJobs, toggleDetail } = this.props;
    clearSelectedJobs();
    toggleDetail();
  };

  render() {
    const {
      className,
      hasResults,
      isSelected,
      offset,
      orgJobs,
      pageOrgJobs,
      searchId,
      searchText,
      showSearch,
      totalCount
    } = this.props;
    const paginationClass = classnames({
      orgJobs__pagination: showSearch,
      'orgJobs__pagination-only': !showSearch
    });
    const containerClass = classnames({
      org__jobs: true,
      [className]: className
    });
    const shouldShowMore = !!orgJobs.length && orgJobs.length % STEP === 0 && orgJobs.length !== totalCount;

    return (
      <div className={containerClass}>
        {showSearch ? (
          <Search
            className="facets__search"
            id={searchId}
            onChange={this.getText}
            onClick={this.clearSearch}
            placeholder="Search jobs"
            value={searchText}
          />
        ) : (
          <div className="org__jobs-link">
            <a onClick={this.toggleDetail}>
              <i className="icon-reply" />
              Back to select job
            </a>
          </div>
        )}
        {hasResults ? (
          <div className="orgJobs__placeholder">
            <Placeholder
              className="pxl-text-small pxl-text-muted"
              imagePath="/view/static/mp/images/empty_results.svg"
              secondaryText="There are no results for your search criteria."
              showText={true}
            />
          </div>
        ) : (
          <React.Fragment>
            <div className="org__jobs-list">{this.renderJobs()}</div>
            <Pagination
              pageShowRange={1}
              className={paginationClass}
              isSelected={isSelected}
              offset={offset}
              pageAction={pageOrgJobs}
              shouldShowInput={true}
              shouldShowMore={shouldShowMore}
              shouldShowRanges={showSearch}
              step={STEP}
              totalCount={totalCount}
            />
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default SearchResults;
